import React from 'react';
import { IconX, IconScale } from '@tabler/icons-react';
import { LEAGUE_TERMS_TITLE, LEAGUE_TERMS_FULL, LEAGUE_TERMS_VERSION } from './LeagueTerms';

const TermsModal = ({ onClose, onAccept, showAcceptButton = false }) => {
  return (
    <div className="ls-terms-modal-overlay" onClick={onClose}>
      <div className="ls-terms-modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="ls-terms-modal-header">
          <div className="ls-modal-title">
            <IconScale size={24} />
            <h2>{LEAGUE_TERMS_TITLE}</h2>
          </div>
          <span className="ls-terms-version">v{LEAGUE_TERMS_VERSION}</span>
          <button className="ls-close-btn" onClick={onClose}>
            <IconX size={24} />
          </button>
        </header>

        <div className="ls-terms-modal-body">
          <pre className="ls-terms-text">{LEAGUE_TERMS_FULL}</pre>
        </div>

        <footer className="ls-terms-modal-footer">
          {showAcceptButton ? (
            <>
              <button className="ls-btn-secondary" onClick={onClose}>
                Cancel
              </button>
              <button className="ls-btn-primary" onClick={onAccept}>
                I Accept These Terms
              </button>
            </>
          ) : (
            <button className="ls-btn-primary" onClick={onClose}>
              Close
            </button>
          )}
        </footer>
      </div>
    </div>
  );
};

export default TermsModal;
